import { LoadingSpinner } from '@pesto/ui';
import { Navigate, Outlet } from 'react-router-dom';

import type { UserRole } from '../__generated__/graphql/api';

import { routeConstant } from '../constants/routes';
import { useCurrentRole } from '../hooks/useCurrentRole';

interface RoleProtectedRouteProps {
  allowedRoles: UserRole[];
}

export const RoleProtectedRoute = ({ allowedRoles }: RoleProtectedRouteProps) => {
  const { role, isLoading } = useCurrentRole();

  if (isLoading) {
    return (
      <div className="flex h-full items-center justify-center">
        <LoadingSpinner size={32} />
      </div>
    );
  }

  if (!allowedRoles.includes(role)) {
    return <Navigate to={routeConstant.home} replace />;
  }

  return <Outlet />;
};
